import { useCallback } from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import { connect } from 'react-redux';

import { legacyTheme, styled } from '@prose-ui/legacy';

import { Button } from 'Components/LegacyButton';
import { Typography } from 'Components/Typography';

import ProductCardCheckout from '../Blocks/ProductCardCheckout';

import { trackPreselect } from 'dux/tracking/actions';
import { getAllCTAProps } from 'dux/userFlows/selectors';

import { useCheckoutCategory } from '../hooks/useCheckoutCategory';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 'calc(140px + 30vw)';
  ${legacyTheme.breakpoints.up('md')} {
    padding: ${legacyTheme.props.verticalSpacingMob} ${legacyTheme.props.minimumBlockPadding} 0;
  }
`;

const ProductPreviewAtCart = ({ allCtaProps, preselectOnCart, products, className }) => {
  const checkoutCategory = useCheckoutCategory();
  /* If only one product in this section, the behavior is unchanged.
  Otherwise we redirect to the general consultation instead of a specific one */
  const onlyProduct = products[0];
  const isAlone = products.length === 1;
  const onClick = useCallback(() => {
    if (isAlone) {
      preselectOnCart({
        productSlug: onlyProduct.type,
        locationId: 'cart-page',
      });
    }
  }, [preselectOnCart, isAlone]);

  const { dataClick, to } = isAlone
    ? allCtaProps[onlyProduct.type]
    : { dataClick: 'update-consultation', to: '/consultation/haircare' };
  return (
    <Wrapper className={className}>
      <Typography align="center" paragraph variant="h2">
        {isAlone
          ? `Complete your hair journey with custom ${onlyProduct.label}`
          : 'Complete your journey with our latest custom products'}
      </Typography>

      <Typography align="center" color="grey" paragraph variant="p2">
        Answer the new Q’s in our consultation to get your fully personalized system.
      </Typography>

      <Button
        Component={Link}
        data-click={dataClick}
        data-from="cart"
        data-testid={`${isAlone ? onlyProduct.type : 'consultation'}-preview-cart-cta`}
        onClick={onClick}
        to={to}
        variant="vertFull"
      >
        Update my consultation
      </Button>

      {products.map(product => (
        <ProductCardCheckout
          key={`${product.type}-with-subscription`}
          checkoutCategory={checkoutCategory}
          disabled
          fromGiftSet={false}
          onModalOpen={() => {}}
          product={product}
        />
      ))}
    </Wrapper>
  );
};

ProductPreviewAtCart.propTypes = {
  allCtaProps: PropTypes.shape({
    styling_gel: PropTypes.shape({
      to: PropTypes.string.isRequired,
      dataClick: PropTypes.string.isRequired,
    }),
    supplements: PropTypes.shape({
      to: PropTypes.string.isRequired,
      dataClick: PropTypes.string.isRequired,
    }),
  }),
  preselectOnCart: PropTypes.func.isRequired,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  className: PropTypes.string,
};

ProductPreviewAtCart.defaultProps = {
  products: [],
  allCtaProps: {},
  className: null,
};

export default connect(
  state => ({
    allCtaProps: getAllCTAProps(state),
  }),
  {
    preselectOnCart: trackPreselect,
  }
)(ProductPreviewAtCart);
